import L from "leaflet";
import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

const constructionIcon = L.icon({
  iconUrl:
    process.env.PUBLIC_URL + "/mapicons/Construction/Construction_A_v9.png",

  iconSize: [21, 21], // size of the icon
  popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
});

const getLeafletIcon = (feature, latlng, map, pane) => {
  let title = " Construction - " + getClosureDetails(feature.properties);
  let icon = feature.properties.mo ? constructionIcon : constructionIcon;

  return L.marker(latlng, {
    icon: icon,
    title: title,
    alt: title,
    pane: pane,
  });
};

const getClosureDetails = (properties) => {
  return properties.closure;
};

const PopupTemplate = (props) => {
  const feature = props.feature;

  return <Construction feature={feature} />;
};

const Construction = (props) => {
  const feature = props.feature;
  const properties = feature.properties;
  const isAdmin = sessionStorage.getItem("isAdmin");

  if (isAdmin === "true") {
    return (
      <Card sx={{ borderRadius: 3 }}>
        <CardHeader
          avatar={
            <Avatar
              alt="Construction"
              src={
                process.env.PUBLIC_URL +
                "/mapicons/Construction/Construction_A_v9.png"
              }
              sx={{ width: 21, height: 21 }}
              aria-label="construction"
            ></Avatar>
          }
          title={<font className="layer-title">Road Work </font>}
          className={"styledtablerow"}
          sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
        />
        <CardContent
          sx={{
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 1,
            paddingRight: 1,
          }}
        >
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>
                  <div>{properties.locDesc}</div>
                  {properties.desc}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table size="small">
            <TableBody>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>
                  Closure&nbsp;Details
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.closure}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>
                  Time Periods
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.time}
                </TableCell>
              </TableRow>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>Duration</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.dur}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>Severity</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.sev}
                </TableCell>
              </TableRow>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>Source</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.src}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>
                  Last Updated
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.lstUpd}
                </TableCell>
              </TableRow>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>ID</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.id}
                </TableCell>
              </TableRow>
              {properties.mo && (
                <TableRow>
                  <TableCell className={"layertablecellLeft"}>
                    Moving&nbsp;Operation
                  </TableCell>
                  <TableCell className={"layertablecellRight"}>
                    {String(properties.mo)}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  } else {
    return (
      <Card sx={{ borderRadius: 3 }}>
        <CardHeader
          avatar={
            <Avatar
              alt="Construction"
              src={
                process.env.PUBLIC_URL +
                "/mapicons/Construction/Construction_A_v9.png"
              }
              sx={{ width: 21, height: 21 }}
              aria-label="construction"
            ></Avatar>
          }
          title={<font className="layer-title">Road Work </font>}
          className={"styledtablerow"}
          sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
        />
        <CardContent
          sx={{
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 1,
            paddingRight: 1,
          }}
        >
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>
                  <div>{properties.locDesc}</div>
                  {properties.desc}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table size="small">
            <TableBody>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>
                  Closure&nbsp;Details
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.closure}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>
                  Time Periods
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.time}
                </TableCell>
              </TableRow>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>Duration</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.dur}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>Severity</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.sev}
                </TableCell>
              </TableRow>
              <TableRow className={"styledtablerow"}>
                <TableCell className={"layertablecellLeft"}>Source</TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.src}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={"layertablecellLeft"}>
                  Last Updated
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {properties.lstUpd}
                </TableCell>
              </TableRow>
              {properties.mo && (
                <TableRow className={"styledtablerow"}>
                  <TableCell className={"layertablecellLeft"}>
                    Moving&nbsp;Operation
                  </TableCell>
                  <TableCell className={"layertablecellRight"}>
                    {String(properties.mo)}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  }
};

const createClusterIcon = (cluster) => {
  return L.divIcon({
    html: `<span></span>`,
    className: "cluster-construction",
    iconSize: L.point(21, 21, true),
  });
};

const style = {
  weight: 5,
  opacity: 0.9,
  color: "#fcba03",
  lineCap: "square",
};

const closedstyle = {
  weight: 5,
  opacity: 0.9,
  color: "red",
  lineCap: "square",
};

const transparentStyle = {
  weight: 5,
  opacity: 0,
  color: "#fcba03",
  lineCap: "square",
};

const isFullClosure = (feature) => {
  return feature.properties.lanes?.toLowerCase() === "full";
};

const hasClosure = (feature) => {
  return (
    (feature.properties.lanes?.toLowerCase() === "full" ||
      feature.properties.lanes?.toLowerCase() === "partial") &&
    !feature.properties.mo
  );
};

const onEachFeature = (feature, layer) => {
  if (feature.geometry.geometries.length > 1) {
    let idx = 0;
    layer.eachLayer((layer) => {
      const layerfeature = feature.geometry.geometries[idx];
      if ("MultiLineString" === layerfeature.type) {
        if (isFullClosure(feature)) {
          layer.setStyle(closedstyle);
        } else {
          if (!feature.properties.mo) {
            layer.setStyle(style);
          } else {
            layer.setStyle(transparentStyle);
          }
        }
      }
      idx++;
    });
  }
};

const styleFunction = (feature) => {
  if (isFullClosure(feature)) {
    return closedstyle;
  } else {
    if (!feature.properties.mo) {
      return style;
    } else {
      return transparentStyle;
    }
  }
};

const module = {
  name: "Construction",
  endpoint: "/constructionMap.json?type=lines",
  showOnMap: true,
  getLeafletIcon: getLeafletIcon,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL + "/mapicons/Construction/Construction_A_v9.png",
  clusterLayer: true,
  iconCreateFunction: createClusterIcon,
  maxZoom: 10,
  zIndex: 630,
  style: styleFunction,
  onEachFeature: onEachFeature,
  hasClosure: hasClosure,
};

export default module;
